import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import CarLeasingItem from 'desktop/components/CarLeasingItem/CarLeasingItem';
import { DesktopButton } from 'shared/components/BannerAll';
import s from './CarsLeasingList.css';

class CarsLeasingList extends React.Component {
  static propTypes = {
    cars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currentPage: PropTypes.number.isRequired,
  };
  static defaultProps = {
    targetingArguments: {},
  };
  render() {
    const { cars, currentPage } = this.props;

    return (
      <div className={s.root}>
        {cars &&
          cars.length > 0 &&
          cars.map((item, idx) =>
            <React.Fragment key={item.id}>
              {idx === 6 && <DesktopButton />}
              <CarLeasingItem car={item} key={item.id} currentPage={currentPage} index={idx} />
            </React.Fragment>,
          )}
      </div>
    );
  }
}

export default withStyles(s)(CarsLeasingList);



// WEBPACK FOOTER //
// ./src/desktop/components/CarsLeasingList/CarsLeasingList.js